import axios from '@/core/axios'
import { Order } from 'stoux-shared-types/models/order'
import { ListOrdersDto, ListOrdersRes } from '../dtos/list-orders'
import OrderRepository from '../repositories/order'
import { ListOrdersSchema } from '../schemas/list-orders'

type InjectedDependencies = {
    orderRepository: OrderRepository
}

type FeedbackOrderResponse = {
    stores: {
        orderId: string
        storeId: string
        storeName: string
        items: Order['items']
    }[]
    orderId: string
}

export default class OrderService {
    constructor(private readonly container: InjectedDependencies) {}

    /**
     * This will list all the orders for the logged in customer
     */
    async listOrders(dto: ListOrdersDto): Promise<ListOrdersRes> {
        const validatedDto = await ListOrdersSchema.safeParseAsync(dto)

        if (!validatedDto.success) throw new Error('Invalid listOrders dto')

        return await this.container.orderRepository.listOrdersForCustomer(
            validatedDto.data,
        )
    }

    async retrieveOrder(orderId: string): Promise<Order> {
        const { data } = await axios.get<{ order: Order }>(`/orders/${orderId}`)
        return data.order
    }

    async retrieveFeedbackOrder(orderId: string) {
        const { data } = await axios.get<FeedbackOrderResponse>(
            `/orders/${orderId}/feedback`,
        )
        return data
    }

    async cancelOrder(orderId: string): Promise<Order> {
        const { data } = await axios.post<{ order: Order }>(
            `/orders/${orderId}/cancel`,
        )
        return data.order
    }
}
